import { FulfillmentMethodsAvailability } from 'types/fulfillment-methods-availability.interface';

export const existsAnyAvailableFulfillmentMethodOnArea = (
  availability: FulfillmentMethodsAvailability,
): boolean => Object.values(availability).some((value) => value === true);
